import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import MaterialTable from 'material-table';


// reactstrap components
import { Card, CardBody, Row, Col, Container, Modal, ModalBody, Button, ModalFooter } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import Identificacao from "../../../views/Shared/Gerador/Identificacao";
import LocaisColeta from "../../../views/Shared/Gerador/LocaisColeta";
import Residuos from "../../../views/Shared/Gerador/Residuos";
import Documentos from "../../../views/Shared/Documentos";
import Declaracao from "../../../views/Shared/Declaracao";
import CaracterizacaoResiduos from 'views/Shared/Gerador/CaracterizacaoResiduos';

//Contants
import { table_translate, table_style } from '../../../constants/MaterialTable';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';

export default function GeradorRequerimentoNovoCadastro({ history }) {
    const { session, setupSistema } = useAuth();

    const [requerimento, set_requerimento] = useState(null);

    // State para pega a opção do cadastro
    const [opcao, set_opcao] = useState(null);

    // State para definir o passa a passa do formulário
    const [steps, setSteps] = useState([]);

    //State para modal
    const [isModal, setIsModal] = useState(false);

    //Função para alterar o state do modal
    const toggle = () => setIsModal(!isModal);

    //State para pegar os transportadores no sistema de cadastro do tipo RGG
    const [list_transportadoresRGG, set_list_transportadores] = useState([]);

    //State para controlar o botão para aparecer ou não a olista dos transportadores
    const [visualizarTransportadores, setVisualizarTransportadoes] = useState(false);

    const [step, set_step] = useState(0);
    const handleProximoStep = (_requerimento) => {
        set_requerimento(_requerimento);
        set_step(step + 1);
    }

    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadTransportadoresRGG = () => {
        api_GET('ProtocoloTransportador/GetListTransportadoresRGG').then(result => {
            set_list_transportadores(result.data.map(value => {
                value.telefone = mascaras.telefoneMask(value.telefone);
                return value;
            }))
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
    }

    const loadRequerimento = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        if (params != null && params.protocolo != null) {
            api_GET('requerimento/ByNumeroProtocolo/' + params.protocolo)
                .then(result => {
                    set_opcao({
                        tipoCadastro: "Requerimento",
                        segmento: "Grande Gerador",
                        categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                    });

                    if (result.data.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla != "RGG") {
                        setSteps(['Identificação', 'Locais de Coleta', 'Resíduos', 'Documentação']);
                        setIsModal(false);
                    } else {
                        setSteps(['Identificação', 'Locais de Coleta', 'Caracterização dos Residuos', 'Documentação']);
                        if (result.data.requerimentoGeradorLocal.length == 0) {
                            loadTransportadoresRGG();
                        }
                        setIsModal(true)
                    }
                    set_requerimento(result.data);

                    if (result.data.status == "Divergente")
                        set_step(0);
                    else if (result.data.etapaCadastro != null)
                        set_step(result.data.etapaCadastro);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
        }
    }

    useEffect(() => {
        loadRequerimento();
    }, []);


    return (
        <>
            {isModal && step == 0 &&
                <Modal isOpen={isModal} toggle={toggle} centered size={"lg"}>
                    <ModalBody>
                        <Row>
                            <Col md={12} lg={12} className={"mb-1"}>
                                <p>Você já possui contrato de coleta privada?</p>
                            </Col>
                            <Col md={12} lg={12} className={"mb-1"}>
                                <p>
                                    Caso possua, pode prosseguir para a próxima etapa, onde você deverá informar o endereço de coleta e incluir o contrato que possui com o Transportador.
                                </p>
                            </Col>
                            <Col md={12} lg={12} className={"mb-1"}>
                                <p>
                                    Caso não possua, verifique abaixo a lista dos Transportadores credenciados na SP Regula. Para prosseguir com seu cadastro, você terá que contratar a coleta privada primeiro, pois será necessário incluir o contrato de prestação de serviços na solicitação de cadastro.
                                </p>
                            </Col>
                        </Row>
                        {list_transportadoresRGG.length > 0 &&
                            <Row>
                                <Col md={12} lg={5}>
                                    <Button
                                        color={"primary"}
                                        onClick={() => setVisualizarTransportadoes(!visualizarTransportadores)}
                                    >
                                        <i className='fas fas fa-search'></i> Visualizar transportadores
                                    </Button>
                                </Col>
                                {visualizarTransportadores &&
                                    <Col md={12} lg={12}>
                                        <MaterialTable style={{ minHeight: "auto", zIndex: 0 }}
                                            title=""
                                            columns={[
                                                { title: 'Razão Social', field: 'razaoSocial' },
                                                { title: 'Telefone', field: 'telefone' }
                                            ]}
                                            data={list_transportadoresRGG}
                                            isLoading={false}
                                            localization={table_translate}
                                            options={{
                                                ...table_style,
                                                filtering: false,
                                                exportButton: true
                                            }}
                                        />
                                    </Col>
                                }
                            </Row>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>Continuar</Button>
                    </ModalFooter>
                </Modal>
            }

            {requerimento != null && opcao != null &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className="text-danger">Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }

                    {step == 0 &&
                        <Identificacao
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep} />
                    }

                    {step == 1 &&
                        <LocaisColeta
                            item={requerimento}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior} />
                    }

                    {opcao.categoria.sigla != "RGG" && step == 2 &&
                        <Residuos
                            item={requerimento}
                            opcao={opcao}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />

                    }

                    {opcao.categoria.sigla == "RGG" && step == 2 &&
                        <CaracterizacaoResiduos
                            item={requerimento}
                            opcao={opcao}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }

                    {step == 3 &&
                        <Documentos
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }

                    {step == 4 &&
                        <Declaracao
                            item={requerimento}
                            handleFinalizarCadastro={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }
                </div>
            }

            {requerimento != null && opcao != null && step == 5 &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}